import { cloneDeep } from 'lodash';

export default {
    // Default state can be overriden/supplied by the backend via VuexService class.
    state: {
        apps: [],
        deactivatedApp: null,
    },

    mutations: {
        updateApp(state, app) {
            let appIndex = state.apps.findIndex(a => a.name == app.name);
            state.apps[appIndex] = {...app};
        },

        removeApp(state, app) {
            state.apps = state.apps.filter(a => a.name != app.name);
        },

        ON_DEACTIVATE_APP (state, payload) {
            state.deactivatedApp = payload;
        }
    },

    actions: {
        onDeactivateApp ({commit}, appId) {
            commit('ON_DEACTIVATE_APP', appId);
        }
    },

    getters: {
        translatedApps(state) {
            return cloneDeep(state.apps).map(item => {
                if (item.label_key) {
                    item.label = this.trans(item.label_key);
                }
                return item;
            });
        },

        findAppByName: (state) => (appName) => {
            if (state.apps && state.apps.length > 0) {
                let app = state.apps.find(app => app.name == appName);

                if (!app) {
                    console.error(`[apps/findAppByName] App "${appName}" not found. Make sure you spelt it correctly.`);
                }

                return app;
            }

            return null;
        },

        isAppAvailable: (state, getters) => (appName) => {
            let app = getters.findAppByName(appName);

            return app && app.available;
        },

        isAppEnabled: (state, getters) => (appName) => {
            let app = getters.findAppByName(appName);

            return app && app.enabled;
        },

        canEditAppSettings: (state, getters) => (appName) => {
            let app = getters.findAppByName(appName);

            return app && Boolean(app.can_edit_settings || false);
        },

        appHasSettings: (state, getters) => (appName) => {
            let app = getters.findAppByName(appName);

            return app && Boolean(app.settings_url || false);
        },

        isApp: (state, getters) => (appName) => {
            let app = getters.findAppByName(appName);

            return app && Boolean(app.is_app || false);
        },

        appSettingsUrl: (state, getters) => (appName) => {
            let app = getters.findAppByName(appName);

            return app ? app.settings_url : null;
        },

        appSettingsPath: (state, getters) => (appName) => {
            const url = getters.appSettingsUrl(appName);

            return url ? String(url).replace(Config.get('app.BASEURL'), '') : null;
        },

        allAvailableApps: (state) => {
            return state.apps.filter(app => app.available);
        },

        allEnabledApps: (state) => {
            return state.apps.filter(app => app.enabled);
        },

        allDisabledApps: (state) => {
            return state.apps.filter(app => !app.enabled);
        },
    }
}
